import { PaisType } from "../Pages/Landings/diccionario"
import mapfre from "../Assets/img/logos/cias/logo_mapfre.svg"
import integrity from "../Assets/img/logos/cias/logo_liberty_b.png"
import libra from "../Assets/img/logos/cias/logo_libra.svg"
import sancristobal from "../Assets/img/logos/cias/logo_sancristobal.svg"
import galeno from "../Assets/img/logos/cias/logo_galeno.svg"
import allianz from "../Assets/img/logos/cias/logo_allianz.svg"
import sancor from "../Assets/img/logos/cias/logo_sancor.svg"

export interface Companias {
    nombreCompania: string,
    imgRuta: string,
    mostrar: boolean,
    imgRutaUy?: string,
    pais?: PaisType[]
}
export const imagesCompanias: Companias[] = [
    {
        nombreCompania: "mapfre",
        imgRuta: mapfre,
        mostrar: true,
        pais: []
    },
    {
        nombreCompania: "integrity",
        imgRuta: integrity,
        mostrar: true,
        pais: ["AR"]
    },
    {
        nombreCompania: "libra",
        imgRuta: libra,
        mostrar: true,
        pais: ["AR"]
    },
     {
        nombreCompania: "sancristobal",
        imgRuta: sancristobal,
        mostrar: true,
        pais: ["AR", "UY"]
    },
    {
        nombreCompania: "galeno",
        imgRuta: galeno,
        mostrar: false,
        pais: ["AR"]
    },
     {
        nombreCompania: "allianz",
        imgRuta: allianz,
        mostrar: true,
        pais: ["AR"]
    },
    {
        nombreCompania: "sancor",
        imgRuta: sancor,
        mostrar: true,
        pais: ["AR", "UY"]
    },
]